// eslint-disable-next-line no-unused-vars
import { MaintenanceItem, MaintenanceItemDatePeriodUnit } from '@clients/myTrips'

export default function getMappedItem (item: MaintenanceItem, vehicleId: number) {
  return {
    id: item.id,
    type: item.itemType,
    title: getTitle(item),
    subtitle: getSubtitle(item),
    switchState: item.active,
    location: isP57a(item) ? null : getLocation(item, vehicleId),
    hoverText: isP57a(item) ? null : 'Erinnerung bearbeiten',
    tagIcon: getTagIcon(item),
    hasButton: isP57a(item)
  }
}

function getLocation (item: MaintenanceItem, vehicleId: number) {
  return {
    name: 'maintenanceEdit',
    query: { vehicleId: String(vehicleId) },
    params: { id: item.id }
  }
}

function getTitle (item: MaintenanceItem) {
  if (isP57a(item)) {
    return '§57a Pickerl-Erinnerung'
  } else if (item && item.itemType === 'Anti_freeze') {
    return 'Scheibenfrostschutzmittel nachfüllen'
  }
  return item.name
}

function getTagIcon (item: MaintenanceItem) {
  return { value: 'tag_notification', color: item.active ? '#FFDC00' : '#ccccc9', fill: 'black', position: 10 }
}

function isP57a (item: MaintenanceItem) {
  return item && item.itemType === 'P57a'
}

function getSubtitle (item: MaintenanceItem) {
  if (isP57a(item)) {
    return 'Basierend auf dem Erstzulassungsdatum'
  }

  let subtitle = ''
  if (!item.odometerPeriodKmValue && !item.datePeriodValue && !item.datePeriodUnit) {
    subtitle = 'Einmalig'
  } else {
    if (item.odometerPeriodKmValue) {
      subtitle += `Alle ${item.odometerPeriodKmValue} km`
    }
    if (item.datePeriodUnit && item.datePeriodValue) {
      if (item.odometerPeriodKmValue) {
        subtitle += ' oder '
      }
      switch (item.datePeriodUnit) {
        case MaintenanceItemDatePeriodUnit.DAY:
          if (item.datePeriodValue === 1) {
            subtitle += 'Täglich'
          } else {
            subtitle += `Alle ${item.datePeriodValue} Tage`
          }
          break
        case MaintenanceItemDatePeriodUnit.WEEK:
          if (item.datePeriodValue === 1) {
            subtitle += 'Wöchentlich'
          } else {
            subtitle += `Alle ${item.datePeriodValue} Wochen`
          }
          break
        case MaintenanceItemDatePeriodUnit.MONTH:
          if (item.datePeriodValue === 1) {
            subtitle += 'Monatlich'
          } else if (item.datePeriodValue === 3) {
            subtitle += 'Quartalsweise'
          } else if (item.datePeriodValue === 6) {
            subtitle += 'Halb-Jährlich'
          } else {
            subtitle += `Alle ${item.datePeriodValue} Monate`
          }
          break
        case MaintenanceItemDatePeriodUnit.YEAR:
          if (item.datePeriodValue === 1) {
            subtitle += 'Jährlich'
          } else {
            subtitle += `Alle ${item.datePeriodValue} Jahre`
          }
          break
      }
    }
  }

  return subtitle
}
